module.exports = __webpack_public_path__ + "img/RETURN_SALE.176ec326.svg";